<h3 mat-dialog-title>Add Dependencies</h3>
<mat-dialog-content>
    <form>
        <mat-form-field subscriptSizing="dynamic" style="width: 100%;">
            <mat-label>Select Script</mat-label>
            <mat-select [formControl] = "dependenciesForm" multiple required (selectionChange)="onSelectionDependeciesChange($event)">
                <mat-option value="No dependencies required" [disabled]="isNoDependeciesDefinedSelected">No dependencies required</mat-option>
                <mat-option value="No dependencies already defined" [disabled]="isNoDependeciesRequiredSelected">No dependencies already defined</mat-option>
                <mat-option *ngFor="let dep of dependencies" [value]="dep" [disabled]="isNoDependeciesDefinedSelected || isNoDependeciesRequiredSelected">{{dep}}</mat-option>
            </mat-select>
          </mat-form-field>
      </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="primary" (click)="onDependenciesSubmit()">Save</button>
    <button mat-button [mat-dialog-close]="" cdkFocusInitial>Close</button>
</mat-dialog-actions>